<div class="row h-100">
  <div class="col-12 col-lg-2 ">
      <app-sidebar></app-sidebar>
  </div>
  <div class="main-content col-12 col-lg-10 d-flex flex-column min-vh-100 bg-light">
    <app-header class="container d-block"></app-header>
    <section class="container flex-grow-1">
      <router-outlet></router-outlet>
    </section>
    <app-footer class="container d-block"></app-footer>
  </div>
</div>
